import React, { useEffect, useContext, useState, useRef } from "react";

import {
  Alert,
  Autocomplete,
  Box,
  Button,
  Drawer,
  FormControl,
  FormLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { appLogger, Http } from "../../../src/utils";
import { UserContext } from "../../context/userContext";
import { UserLoginInfo } from "../../types/context";
import {
  ROLE_USER_ADMIN,
  ROLE_USER_MANAGER,
  ROLE_USER_MEMBER,
  ROLE_USER_SUPERADMIN,
  UserInfo,
} from "../../model";
import { roleConfig } from "../../utils/config/role-config";

interface IProps {
  editOpen: boolean;
  editID: UserInfo;
  addOpen: boolean;
  setEditPopup: Function;
  setClosePopup: Function;
  productLists?: [];
}

const UserForm = (props: IProps) => {
  appLogger.info({
    infoObj: {
      method: "UserForm",
      component: "users",
      fileName: "userForm.tsx",
      props: props,
    },
  });
  const { productLists } = props;
  const [open, setOpen] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  // const [phone, setPhone] = useState("");
  const [userId, setUserId] = useState("");
  const [role, setRole] = useState("");
  const [selectedImage, setSelectedImage] = useState<any | null>(null);
  const [imageUrl, setImageUrl] = useState<any | null>(null);
  const [editUser, setEditUser] = useState<any | null>(null);
  const [alertOpen, setAlertOpen] = React.useState(false);
  const [errorAlertOpen, setErrorAlertOpen] = React.useState(false);
  const [editForm, setEditForm] = useState(false);
  const [addForm, setAddForm] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [isLoading, setIsloading] = React.useState(false);
  const [isManager, setIsManager] = useState(false);
  const [userProductRolerowsData, setuserProductRolerowsData] = useState<any>(
    []
  );
  const [orgRole, setOrgRole] = useState("");

  const selectOrgRole = (event: SelectChangeEvent) => {
    setOrgRole((event.target as HTMLInputElement).value);
  };

  useEffect(() => {
    setOpen(props.editOpen);
    setEditUser(props.editID);
    setEditForm(props.editOpen);
    setAddForm(props.addOpen);

    if (props.addOpen) {
      setOrgRole("Member");
    }
  }, [props]);

  useEffect(() => {
    if (editForm) {
      setFirstName(editUser.nameFirst);
      setLastName(editUser.nameLast);
      setEmail(editUser.emailId);
      setUserId(editUser.id);
      if (editUser && editUser.userRole && editUser.userRole.length) {
        setOrgRole(editUser.userRole);
      }
    }
  }, [editForm]);

  const handleDrawerClose = () => {
    setOpen(false);
    props.setEditPopup(false);
    props.setClosePopup(false);

    setFirstName("");
    setLastName("");
    setEmail("");
    setRole("");
    setUserId("");
    // setPhone("");
    setImageUrl(null);
    setSelectedImage(null);
    setEditUser(null);
  };

  const selectRole = (event: SelectChangeEvent) => {
    setRole((event.target as HTMLInputElement).value);
  };

  const handleFirstName = (e: any) => {
    setFirstName(e.target.value);
  };

  const handleLastName = (e: any) => {
    setLastName(e.target.value);
  };

  const handleEmailChange = (e: any) => {
    setEmail(e.target.value);
  };
  // const handlePhoneChange = (e: any) => {
  //   setPhone(e.target.value);
  // };
  useEffect(() => {
    if (selectedImage) {
      setImageUrl(URL.createObjectURL(selectedImage));
    }
  }, [selectedImage]);

  const userResponse = {
    nameFirst: firstName,
    nameLast: lastName,
    emailId: email,
    active: true,
    userRole: orgRole,
    profilePic: imageUrl,
  };

  const { userInfo } = useContext(UserContext) as UserLoginInfo;

  const createUser = (values: any) => {
    if (!firstName || !lastName || !email || !orgRole) {
      setErrorAlertOpen(true);
      setSnackbarMessage("Please fill all the required fields.");
      return;
    }

    setIsloading(true);

    if (editForm) {
      try {
        Http.put({
          url: `/api/v2/users/`,
          body: {
            id: userId,
            emailId: email.toLowerCase(),
            nameFirst: firstName,
            nameLast: lastName,
            userRole: orgRole,
          },
          state: userInfo,
        })
          .then((response) => {
            const data: any = response;
            setSnackbarMessage("User edited successfully!!!");
            setAlertOpen(true);
            setIsloading(false);

            setTimeout(() => {
              setAlertOpen(false);
              handleDrawerClose();
            }, 1000);
          })
          .catch((err) => {
            setErrorAlertOpen(true);
            setSnackbarMessage("User edit failed.");
            setIsloading(false);
            appLogger.error({
              errObj: {
                method: "createUser",
                component: "users",
                fileName: "userForm.tsx",
                err: err,
              },
            });
          });
      } catch (error) {
        appLogger.error({
          errObj: {
            method: "createUser",
            component: "users",
            fileName: "userForm.tsx",
            err: error,
          },
        });
        setIsloading(false);
      }
    } else {
      try {
        let orgId = "";
        if (
          userInfo &&
          userInfo.userDetails &&
          userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN
        ) {
          orgId = userInfo.userDetails.orgId || "";
        }
        Http.post({
          url: `/api/v2/users`,
          body: {
            nameFirst: firstName,
            nameLast: lastName,
            emailId: email.toLowerCase(),
            id: userId,
            orgId: orgId,
            active: true,
            userRole: orgRole,
          },
          state: userInfo,
        })

          .then((response) => {
            const data: any = response;
            setSnackbarMessage("user created successfully!!!");
            setAlertOpen(true);
            setIsloading(false);

            setTimeout(() => {
              setAlertOpen(false);
              handleDrawerClose();
            }, 1000);
          })
          .catch((err) => {
            setSnackbarMessage(
              JSON.parse(JSON.stringify(err))?.apiError?.msg ||
                "Create user failed!!!"
            );
            setErrorAlertOpen(true);
            setIsloading(false);
            appLogger.error({
              errObj: {
                method: "createUser",
                component: "users",
                fileName: "userForm.tsx",
                err: err,
              },
            });
          });
      } catch (error) {
        setIsloading(false);
        appLogger.error({
          errObj: {
            method: "createUser",
            component: "users",
            fileName: "userForm.tsx",
            err: error,
          },
        });
      }
    }
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };

  const handleErrorAlertClose = () => {
    setErrorAlertOpen(false);
  };

  const addTableRows = () => {
    const subGroupInputs: any = {
      groupName: "",
      productIds: [],
    };
    setuserProductRolerowsData([...userProductRolerowsData, subGroupInputs]);
  };

  const deleteTableRows = (index: any) => {
    const rows = [...userProductRolerowsData];
    rows.splice(index, 1);
    setuserProductRolerowsData(rows);
  };

  const handleChange = (index: any, evnt: any, type: any) => {
    const subGroupInputs: any = [...userProductRolerowsData];
    if (type != "product") {
      const { name, value } = evnt.target;
      subGroupInputs[index][name] = value;
    } else {
      subGroupInputs[index]["productIds"] = evnt;
    }
    setuserProductRolerowsData(subGroupInputs);
  };
  const userProdRoleGrpEndRef = useRef<any>(null);
  const scrollToBottom = () => {
    userProdRoleGrpEndRef?.current?.scrollIntoView({ behavior: "smooth" });
  };

  useEffect(scrollToBottom, [userProductRolerowsData]);
  return (
    <Grid>
      <Drawer
        className="user-popup"
        anchor="right"
        open={props.editOpen || props.addOpen}
        onClose={handleDrawerClose}
      >
        <Box sx={{ width: "100%" }}>
          <Box
            className="title-wrap"
            sx={{
              display: "flex",
              alignItems: "center",
              borderBottom: 1,
              borderColor: "divider",
            }}
          >
            <Typography className="title">
              {editForm ? "Edit user" : "create user"}
            </Typography>

            <IconButton className="close-filter" onClick={handleDrawerClose}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>

        <Grid
          sx={{ p: 3 }}
          item
          className={isLoading ? "loader user-form" : "user-form"}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mb: 4,
            }}
          >
            <Box className="user-upload upload-wrap" sx={{ display: "flex" }}>
              {/* <Button
                variant="outlined"
                component="label"
                className="upload-btn"
                onChange={(e: any) => setSelectedImage(e.target.files[0])}
              >
                <i className="icon-upload" />
                <input hidden accept="image/*" multiple type="file" />
              </Button> */}

              {!imageUrl && (
                <Box className="img-preview">
                  <i className="icon-user" />
                </Box>
              )}

              {imageUrl && (
                <Box className="img-preview">
                  <img src={imageUrl} />
                </Box>
              )}
            </Box>

            {/* <Typography
              sx={{
                textTransform: "uppercase",
                fontSize: "13px",
                fontWeight: 500,
              }}
            >
              upload picture
            </Typography> */}
          </Box>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    First name
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={firstName}
                    onChange={handleFirstName}
                    disabled={
                      editForm
                        ? editUser &&
                          editUser.userRole &&
                          userInfo &&
                          userInfo.userDetails &&
                          (userInfo.userDetails.userRole === ROLE_USER_ADMIN ||
                            userInfo.userDetails.userRole ===
                              ROLE_USER_SUPERADMIN ||
                            userInfo.userDetails.userRole ===
                              ROLE_USER_MANAGER ||
                            editUser.userRole === ROLE_USER_MEMBER)
                          ? false
                          : true
                        : false
                    }
                    id="fname-input"
                    label="First Name"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Last name
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={lastName}
                    onChange={handleLastName}
                    disabled={
                      editForm
                        ? editUser &&
                          editUser.userRole &&
                          userInfo &&
                          userInfo.userDetails &&
                          (userInfo.userDetails.userRole === ROLE_USER_ADMIN ||
                            userInfo.userDetails.userRole ===
                              ROLE_USER_SUPERADMIN ||
                            userInfo.userDetails.userRole ===
                              ROLE_USER_MANAGER ||
                            editUser.userRole === ROLE_USER_MEMBER)
                          ? false
                          : true
                        : false
                    }
                    id="lname-input"
                    label="Last Name"
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Email address
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    value={email}
                    id="email-input"
                    onChange={handleEmailChange}
                    label="Email Address"
                    disabled={editForm ? true : false}
                  />
                </FormControl>
              </Box>
            </Grid>

            <Grid item xs={12} md={6}>
              <Box>
                {/* <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Phone
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <OutlinedInput
                    type="text"
                    // value={""}
                    id="email-input"
                    onChange={handlePhoneChange}
                    label="Phone"
                    disabled={editForm ? true : false}
                  />
                </FormControl> */}
                <FormControl className="custom-select" fullWidth>
                  <InputLabel>
                    Org-Role
                    <div style={{ display: "inline-block", color: "red" }}>
                      *
                    </div>
                  </InputLabel>
                  <Select
                    labelId="role-select"
                    id="role-select"
                    value={orgRole}
                    label="Role"
                    onChange={selectOrgRole}
                    disabled={
                      editForm
                        ? (userInfo &&
                            userInfo.userDetails &&
                            editUser &&
                            userInfo.userDetails.emailId ===
                              editUser.emailId) ||
                          !(
                            editUser &&
                            editUser.userRole &&
                            userInfo &&
                            userInfo.userDetails &&
                            (userInfo.userDetails.userRole ===
                              ROLE_USER_ADMIN ||
                              userInfo.userDetails.userRole ===
                                ROLE_USER_SUPERADMIN ||
                              userInfo.userDetails.userRole ===
                                ROLE_USER_MANAGER ||
                              editUser.userRole === ROLE_USER_MEMBER)
                          )
                          ? true
                          : false
                        : false
                    }
                  >
                    {/* {rolesValue.length > 0 &&
                      rolesValue.map((role: string) => (
                        <MenuItem key={role} value={role}>
                          {role}
                        </MenuItem>
                      ))} */}
                    {editUser &&
                      userInfo &&
                      userInfo.userDetails &&
                      userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN &&
                      editUser.userRole === ROLE_USER_SUPERADMIN && (
                        <MenuItem
                          key="0"
                          value={roleConfig[ROLE_USER_SUPERADMIN]}
                        >
                          SuperAdmin
                        </MenuItem>
                      )}
                    {editUser &&
                      userInfo &&
                      userInfo.userDetails &&
                      (userInfo.userDetails.userRole === ROLE_USER_ADMIN ||
                        userInfo.userDetails.userRole ===
                          ROLE_USER_SUPERADMIN ||
                        editUser.userRole === ROLE_USER_ADMIN) && (
                        <MenuItem key="1" value={roleConfig[ROLE_USER_ADMIN]}>
                          Admin
                        </MenuItem>
                      )}
                    {editUser &&
                      userInfo &&
                      userInfo.userDetails &&
                      (userInfo.userDetails.userRole === ROLE_USER_ADMIN ||
                        userInfo.userDetails.userRole ===
                          ROLE_USER_SUPERADMIN ||
                        userInfo.userDetails.userRole ===
                          ROLE_USER_MANAGER) && (
                        <MenuItem key="2" value={roleConfig[ROLE_USER_MANAGER]}>
                          Manager
                        </MenuItem>
                      )}
                    <MenuItem key="3" value={roleConfig[ROLE_USER_MEMBER]}>
                      Member
                    </MenuItem>
                  </Select>
                </FormControl>
              </Box>
            </Grid>
          </Grid>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              mt: 1,
            }}
            className="footer-action-btn"
          >
            {(!editForm ||
              (editUser &&
                editUser.userRole &&
                userInfo &&
                userInfo.userDetails &&
                (userInfo.userDetails.userRole === ROLE_USER_ADMIN ||
                  userInfo.userDetails.userRole === ROLE_USER_SUPERADMIN ||
                  userInfo.userDetails.userRole === ROLE_USER_MANAGER ||
                  editUser.userRole === ROLE_USER_MEMBER))) && (
              <>
                <Button variant="outlined" onClick={handleDrawerClose}>
                  close
                </Button>
                <Button
                  variant="contained"
                  onClick={() => createUser(userResponse)}
                >
                  save
                </Button>{" "}
              </>
            )}
          </Box>
        </Grid>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleAlertClose}
        >
          <Alert onClose={handleAlertClose} severity="success">
            {snackbarMessage}
          </Alert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={errorAlertOpen}
          autoHideDuration={2000}
          onClose={handleErrorAlertClose}
        >
          <Alert onClose={handleErrorAlertClose} severity="error">
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Drawer>
    </Grid>
  );
};

export default UserForm;
